import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';

interface CustomIconButtonProps {
  fontSize?: string;
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  color: #000;
  padding: 16px;
  border-radius: 16px 16px 0px 0px;
  border: 1px solid #e0e0e0;
  width: auto;
`;

export const Title = styled(Typography)`
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ActionsContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  width: 33%;
`;

export const PageIndicatorWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 82px;
`;

export const CustomIconButton = styled.button<CustomIconButtonProps>`
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &[data-active='true'] {
    background-color: #0000000a;
  }

  &:hover {
    background-color: #0000000a;
  }

  &:disabled {
    svg {
      color: #0000001f;
    }
  }

  svg {
    font-size: ${props => props.fontSize ?? '25px'};
    color: #000;
  }
`;

export const ContainerZoom = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 140px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 8px;
  color: #000;
  font-size: 14px;
`;

export const TextZoom = styled(Box)`
  font-size: 14px;
  margin-right: 8px;
  font-weight: 500;
`;

export const SkeletonCustom = styled(Skeleton)`
  &.MuiSkeleton-root {
    width: 33%;
    height: 40px;
  }
`;

export const TitleSection = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
  width: 33%;
`;

export const RightActions = styled(Box)`
  display: flex;
  width: 33%;
  justify-content: flex-end;
`;
